import React, { Component } from 'react'
import { connect } from 'react-redux'
import * as R from 'ramda'

import FormComponent from './Component'
import { riskReducer } from './reducer'
import injectReducer from 'helpers/injectReducer'
import {
  getPath,
  combinePath
} from 'containers/Form/util'

const withReducer = (path, id) => {
  const valuePath = getPath(path, id)
  return injectReducer(valuePath, riskReducer)
}

export default R.curry((path, id) => R.compose(
  withReducer(path, id),
)(FormComponent))
